import React from "react";
import { ShieldCheck, Zap, Truck, BadgeCheck } from "lucide-react";

// Compact dark-ink strip — sits right under the Hero to immediately
// reassure first-time visitors that they're buying from a registered
// US company with secure checkout, fast processing and dual-warehouse
// shipping (USA + Europe). Mobile: horizontal scroll. Desktop: 4 cols.
const ITEMS = [
  {
    icon: <span aria-hidden className="text-[18px] leading-none">🇺🇸</span>,
    title: "Registered US Company",
    sub: "Compliant & US-based",
    testId: "us-strip-company",
  },
  {
    icon: <ShieldCheck size={16} className="text-[#22c55e]" />,
    title: "Total Security checkout",
    sub: "Stripe · SSL 256-bit · PCI-DSS",
    testId: "us-strip-security",
  },
  {
    icon: (
      <span aria-hidden className="text-[18px] leading-none whitespace-nowrap">
        🇺🇸🇪🇺
      </span>
    ),
    title: "Ships from USA & Europe",
    sub: "2-5 day tracked delivery",
    testId: "us-strip-warehouses",
  },
  {
    icon: <Zap size={16} className="text-[#d8f06b]" />,
    title: "Orders processed in 24h",
    sub: "Same-day if before 2pm EST",
    testId: "us-strip-fast",
  },
];

export default function UsCompanyStrip() {
  return (
    <section
      data-testid="us-company-strip"
      className="bg-[#0e0e10] text-white py-5 md:py-6 border-y border-white/5"
    >
      <div className="container-x">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {ITEMS.map((it) => (
            <div
              key={it.title}
              data-testid={it.testId}
              className="flex items-start gap-3"
            >
              <div className="shrink-0 w-9 h-9 rounded-full bg-white/5 border border-white/10 inline-flex items-center justify-center">
                {it.icon}
              </div>
              <div className="min-w-0">
                <div className="text-[12.5px] md:text-[13px] font-extrabold text-white leading-tight">
                  {it.title}
                </div>
                <div className="text-[10.5px] md:text-[11px] text-white/55 mt-0.5 leading-snug">
                  {it.sub}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Single-line reassurance below — visible on all viewports */}
        <div className="mt-4 pt-4 border-t border-white/5 text-center text-[11px] md:text-[12px] text-white/60 font-medium inline-flex w-full justify-center items-center gap-2 flex-wrap">
          <BadgeCheck size={13} className="text-[#d8f06b]" />
          <span>
            <span className="text-white font-bold">Trusted by 12,400+ sleepers</span>{" "}
            worldwide · Free worldwide shipping · 100-night risk-free trial
          </span>
        </div>
      </div>
    </section>
  );
}
